export const batchGoodsGet = "/sys/spu/batch"//批量导入记录
export const batchGoodsGetNumbers = "/sys/spu/batch-numbers"//获取所有待审核商品的批次号列表
export const batchAuditPost = "/sys/spu/batch-audit"//批量审核商品